export const T = {
  bg: "#FAF7F2", bgSoft: "#F5EFE6", card: "#FFFFFF",
  gold: "#C8A46A", goldD: "#B28C4B", goldL: "#F5EDE0",
  champagne: "#E8D7BC", border: "#EFE7DA",
  success: "#6FAE5C", warning: "#E8B04A", danger: "#E27C7C",
  textPri: "#2B2B2B", textSec: "#777777",
  serif: "'Cormorant Garamond',Georgia,serif",
  sans: "'DM Sans','Inter',sans-serif",
};